import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import './index.css';
import App from "./App";
import setupAxiosInterceptors from './api/axios';

setupAxiosInterceptors();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA with auto-update
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('✅ Service Worker registered successfully:', registration.scope);

        // Check for updates immediately
        registration.update();

        // Check for updates every 30 seconds
        setInterval(() => {
          registration.update();
        }, 30000);

        // When a new SW is waiting, tell it to skip waiting
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          console.log('🔄 New Service Worker found, installing...');

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('📦 New content available, refreshing...');
              // Tell the new SW to skip waiting
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });

        // When the new SW takes over, reload the page
        let refreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (!refreshing) {
            refreshing = true;
            console.log('✨ Controller changed, reloading page...');
            window.location.reload();
          }
        });
      })
      .catch(error => {
        console.log('❌ Service Worker registration failed:', error);
      });
  });
}
